/* RESPONSIBLE TEAM: team-integration-apps */
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Session from 'embercom/services/session';
import type { IntegrationResponse } from 'embercom/components/inbox2/conversation-details-sidebar/sidebar-sections/shopify/types';

export default class ShopifyCompensationConfig extends Service {
  @service declare session: Session;

  @tracked private stores: IntegrationResponse[] = [];
  @tracked private selectedDomain: string | undefined;

  private get selectedStore(): IntegrationResponse | undefined {
    return this.stores.find((s) => s.shopify_domain === this.selectedDomain);
  }

  get partialRefundsEnabled(): boolean {
    let val = this.selectedStore?.partial_refunds_enabled;
    if (val !== null && val !== undefined) {
      return val;
    }
    return this.session.workspace.isFeatureEnabled('tdf-shopify-partial-refunds');
  }

  get replacementOrdersEnabled(): boolean {
    return this.selectedStore?.replacement_orders_enabled ?? false;
  }

  get giftCardCompensationEnabled(): boolean {
    return this.selectedStore?.gift_card_compensation_enabled ?? false;
  }

  get replacementItemsEnabled(): boolean {
    return this.selectedStore?.replacement_items_enabled ?? false;
  }

  get giftCardLimitPercentage(): number | null {
    return this.selectedStore?.gift_card_limit_percentage ?? null;
  }

  get perItemRefundReasonEnabled(): boolean {
    let val = this.selectedStore?.per_item_refund_reason_enabled;
    if (val !== null && val !== undefined) {
      return val;
    }
    return this.session.workspace.isFeatureEnabled('tdf-shopify-per-item-refund-reason');
  }

  get discountCodesEnabled(): boolean {
    let val = this.selectedStore?.discount_codes_enabled;
    if (val !== null && val !== undefined) {
      return val;
    }
    return this.session.workspace.isFeatureEnabled('tdf-shopify-discount-codes');
  }

  updateConfig(stores: IntegrationResponse[], selectedDomain?: string) {
    this.stores = stores;
    this.selectedDomain = selectedDomain;
  }
}

declare module '@ember/service' {
  interface Registry {
    'shopify-compensation-config': ShopifyCompensationConfig;
  }
}
